<template>
    <form-group
            :name="name"
            :label="label"
            :help-text="helpText"
            :error="error"
            :label-width="labelWidth"
            :input-width="inputWidth"
            :button-width="buttonWidth"
            :button-text="buttonText"
            :disabled="disabled"
            @click="$emit('click')"
    >
        <select-widget
                :name="name"
                :value="value"
                :options="options"
                :placeholder="placeholder"
                :nullable="nullable"
                :disabled="disabled"
                @input="$emit('input', $event)"
        ></select-widget>
    </form-group>
</template>

<script>
    import FormGroup from "@/components/FormGroups/Horizontal/FormGroupWithButton"
    import SelectWidget from "@/vendor/forms/FormGroups/Widgets/Select"

    export default {
        components: {FormGroup, SelectWidget},

        props: {
            "name": {},
            "label": {},
            "helpText": {"default": null},
            "value": {},
            "error": {},
            "labelWidth": {},
            "inputWidth": {},
            "buttonWidth": {},
            "buttonText": {"default": '<i class="fa fa-plus"></i> Create'},
            "options": {},
            "placeholder": {},
            "nullable": {},
            "disabled": {"default": false}
        }
    }
</script>
